import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AccessRoles} from '@rsp/models/enum/access-roles.enum';
import {TenantConfigService} from '@rsp/shared/services/tenant-config.service';
import {ImageUrlBuilderService} from '@rsp/shared/services/image-url-builder.service';
import {RegionalAuthService} from '@rsp/shared/services/regional-auth.service';
import {UserService} from '@rsp/shared/services/user.service';
import {environment} from '@env/environment';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';


@Component({
  selector: 'rsp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public today = new Date();
  public accessRolesEnum: typeof AccessRoles = AccessRoles;

  public url;

  constructor(public tenant: TenantConfigService,
              private http: HttpClient,
              public imageUrlBuilder: ImageUrlBuilderService,
              private authService: RegionalAuthService,
              public userService: UserService,
              private userTracker: UserTrackingService) {

    this.url = environment.baseUrlApi;

  }


  get name() {
    return this.authService.authInfo.username;
  }

  public get isAuth() {
    return this.userService.isAuth();
  }

  get baseURL() {
    return this.authService._baseUrl;
  }

  get authPath() {
    return this.authService._authBasePath;
  }

  public ngOnInit(): void {

  }

  public track(): void {
    this.userTracker.trackEvent('Auth', 'Accounteinstellungen');
  }

  login() {
    this.userTracker.trackEvent('Auth', 'Login');

    this.authService.realmLogin(this.tenant.getId());
  }

  logout() {
    this.userTracker.trackEvent('Auth', 'Logout');
    this.userTracker.resetUserId();

    this.authService.logout();
  }

  /**
   * Keycloak account management ...
   */
  account() {
    this.http
      .request('GET', this.authPath + '/account', {
        headers: {Accept: 'text/plain, */*'},
        responseType: 'text'
      })
      .subscribe((data: string) => {
        // force loading the start page after the logout
        this.authService.authInfo = undefined;
        window.location.href = data + '?referrer=energy-sales-regionalplatform&referrer_uri=' + this.baseURL + '&theme=cooperate-light';
      });
  }
}
